import DeckPreviewImage from "../images/custom-deck-cover-default.png";
import EditIcon from "./icons/EditIcon";

function DeckPreview({ deck, onClick, onEditTitle, isLocked }) {
    const coverImageSrc = deck.coverImageUrl || DeckPreviewImage;

    return (
        <div className="flex flex-col items-center text-center w-48 relative">
            <div
                className="relative w-full bg-white shadow-lg hover:shadow-xl transition-shadow rounded-lg overflow-hidden cursor-pointer"
                onClick={onClick}
            >
                {/* Badge: Custom Deck */}
                {onEditTitle && (
                    <div className="absolute top-0 left-0 px-2 py-1 rounded-br-lg text-xs font-bold shadow-md uppercase tracking-wide z-1 bg-gradient-to-r from-pink-200 via-yellow-200 to-green-200 text-gray-700">
                        Custom Deck
                    </div>
                )}

                {/* Badge: Free Sample (locked standard deck) */}
                {isLocked && (
                    <div className="absolute top-0 left-0 px-2 py-1 rounded-br-lg text-xs font-bold shadow-md uppercase tracking-wide z-1 bg-gradient-to-r from-gray-200 to-white text-gray-700">
                        🔒 Free Preview
                    </div>
                )}

                <img
                    src={coverImageSrc}
                    alt="Deck Cover"
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Title and Edit */}
            <div className="mt-2 flex items-center justify-center gap-2 w-full">
                <button
                    onClick={onClick}
                    className="text-base font-semibold hover:underline"
                    title={deck.title}
                >
                    {deck.title || "Untitled Deck"}
                </button>
                {onEditTitle && (
                    <button
                        className="btn btn-sm btn-ghost p-0 btn-circle"
                        onClick={e => {
                            e.stopPropagation();
                            onEditTitle(deck);
                        }}
                        title="Edit title"
                        aria-label="Edit title"
                    >
                        <EditIcon />
                    </button>
                )}
            </div>

            {/* Metadata */}
            <div className="text-sm text-gray-500 mt-1">
                {deck.cards?.length || 0} cards
            </div>
            {deck.createTime?.seconds && (
                <div className="text-xs text-gray-400">
                    {new Date(deck.createTime.seconds * 1000).toLocaleDateString()}
                </div>
            )}
        </div>
    );
}

export default DeckPreview;
